import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Button from '../Button';
import Link from '../Link';
import SecondaryAction from '../SecondaryAction';
import Style from '../Style';
import { H3, H6, P1, P2 } from '../Typography';

class NoMoreLicenses extends React.PureComponent {
  static propTypes = {
    licensesResetAt: PropTypes.string,
    onGoToPlan: PropTypes.func,
    onCancel: PropTypes.func,
  };
  static defaultProps = {};

  render() {
    const { licensesResetAt, onGoToPlan, onCancel, ...otherProps } = this.props;

    let atTime = ' ';
    if (licensesResetAt !== undefined) {
      atTime = ` ${moment(licensesResetAt)
        .calendar()
        .toLowerCase()} when `;
    }

    return (
      <div
        style={{
          padding: '12rem 3rem 3rem',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <H3>License this&nbsp;clip</H3>
        <H6 style={{ margin: '4.5rem auto 0', maxWidth: '27rem' }}>
          Whoops! You don’t have any more licenses available on your current
          subscription.
        </H6>
        <P1 style={{ margin: '3rem auto 0', maxWidth: '32rem' }}>
          You can seamlessly upgrade to a new plan to continue licensing, or
          wait to license this clip until{atTime}your plan renews.{' '}
        </P1>
        <div style={{ marginTop: '7rem' }}>
          <Button arrow={true} onClick={onGoToPlan}>
            Upgrade Subscription
          </Button>
        </div>
        <SecondaryAction onClick={onCancel}>Cancel</SecondaryAction>
      </div>
    );
  }
}

export default NoMoreLicenses;



// WEBPACK FOOTER //
// ./src/components/NoMoreLicenses/NoMoreLicenses.js